import type { MarketTrade } from '../../api/useMarketTrades';

export type TradeTypeId =
    | 'fill'
    | 'split'
    | 'merge'
    | 'redemption'
    | 'conversion';

export interface TradeTypeOption {
    id: TradeTypeId;
    label: string;
}

export const TRADE_TYPES: readonly TradeTypeOption[] = [
    { id: 'fill', label: 'Fills' },
    { id: 'split', label: 'Splits' },
    { id: 'merge', label: 'Merges' },
    { id: 'conversion', label: 'Conversions' },
    { id: 'redemption', label: 'Redemptions' },
];

export const DEFAULT_TRADE_TYPES: readonly TradeTypeId[] = ['fill'];

export type WalletTrade = MarketTrade & { tradeType: TradeTypeId };

const PREFIX = 'polymarket_';

export function tradeTypeOf(raw: string | null | undefined): TradeTypeId {
    const name = (raw ?? '').replace(PREFIX, '');
    return TRADE_TYPES.some(t => t.id === name)
        ? (name as TradeTypeId)
        : 'fill';
}

export function tradeTypeLabel(id: TradeTypeId): string {
    const label = TRADE_TYPES.find(t => t.id === id)?.label ?? id;
    return label.replace(/s$/, '');
}

export function onlyFills(types: readonly TradeTypeId[]): boolean {
    return types.length === 1 && types[0] === 'fill';
}

export function toggleTradeType(
    types: readonly TradeTypeId[],
    id: TradeTypeId
): TradeTypeId[] {
    const next = types.includes(id)
        ? types.filter(t => t !== id)
        : [...types, id];
    if (next.length === 0) return [...types];
    return TRADE_TYPES.map(t => t.id).filter(t => next.includes(t));
}
